import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.productForm = null;
  }

  connectedCallback() {
    this.productForm = this.closest('[data-ref="product-section-content"]')?.querySelector('[data-ref="product-form"]');

    document.addEventListener(ThemeEvents.variantUpdated, this.updatePrice);
    document.addEventListener(ThemeEvents.toggleCrossSellsUpdated, this.updatePrice);
    document.addEventListener(ThemeEvents.quantityBreaksUpdated, this.updatePrice);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdated, this.updatePrice);
    document.removeEventListener(ThemeEvents.toggleCrossSellsUpdated, this.updatePrice);
    document.removeEventListener(ThemeEvents.quantityBreaksUpdated, this.updatePrice);
  }

  updatePrice = (event) => {
    if (typeof GPOConfigs != 'undefined' && GPOConfigs && typeof GPOConfigs.updateProductPrice == 'function') {
      GPOConfigs.updateProductPrice()
    }
    var WCP_JSON=[];
      if(document.getElementsByClassName('wcp_json_'+updatePrice.id).length){
        WCP_JSON=JSON.parse(document.getElementsByClassName('wcp_json_'+updatePrice.id)[0].innerHTML);
        for(var tempwcp=0; tempwcp < WCP_JSON.variants.length; tempwcp++){
          if(updatePrice.id==WCP_JSON.variants[tempwcp].id){
            updatePrice.price=WCP_JSON.variants[tempwcp].price;
            updatePrice.compare_at_price=WCP_JSON.variants[tempwcp].compare_at_price;
          }
        }
      }	
    const currentPriceContainer = this.querySelector('[data-ref="price-container"]');

    // Le event.detail est null si l'évenement de mise à jour est déclenché par les cross-sells à activer et non par les variantes, dans ce cas là on utilise le DOM actuel
    let newPriceContainer = currentPriceContainer;
    if (event.detail != null) {
      newPriceContainer = event.detail.data.html.querySelector('product-price [data-ref="price-container"]');
    }

    // On demande au formulaire de calculer le prix total (avec les cross-sells, quantités, etc.)
    if (this.productForm != null) {
      const newTotalPrice = this.productForm.getCurrentTotalPrice().price;
      const newTotalCompareAtPrice = this.productForm.getCurrentTotalPrice().compare_at_price;
      const newTotalDifferencePrice = this.productForm.getCurrentTotalPrice().difference_price;

      // On met à jour les prix dans le nouveau DOM à insérer
      const priceElement = newPriceContainer.querySelector('[data-ref="price"]');
      if (priceElement != null) {
        priceElement.innerHTML = formatMoney(newTotalPrice);
      }

      const compareAtPriceElement = newPriceContainer.querySelector('[data-ref="compare-at-price"]');
      if (compareAtPriceElement != null) {
        compareAtPriceElement.innerHTML = '';
        if (newTotalCompareAtPrice > newTotalPrice) {
          compareAtPriceElement.innerHTML = formatMoney(newTotalCompareAtPrice);
        }
      }

      const differencePriceElement = newPriceContainer.querySelector('[data-ref="difference-price-value"]');
      if (differencePriceElement != null) {
        const salesBadgeType = this.dataset.salesBadge;

        if (salesBadgeType === 'percentage' && newTotalCompareAtPrice > newTotalPrice) {
          const percentage = Math.round(((newTotalCompareAtPrice - newTotalPrice) * 100) / newTotalCompareAtPrice);
          differencePriceElement.innerHTML = `${percentage}%`;
        } else {
          differencePriceElement.innerHTML = formatMoney(newTotalDifferencePrice, true);
        }
      }
    }

    if (!newPriceContainer || !currentPriceContainer) return;

    if (currentPriceContainer.innerHTML !== newPriceContainer.innerHTML) {
      currentPriceContainer.replaceWith(newPriceContainer);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
